import { Helmet } from 'react-helmet-async';
import DashboardLayout from '@/components/layout/DashboardLayout';
import { Card, CardContent } from '@/components/ui/card';
import InvoiceSection from '@/components/dashboard/InvoiceSection';

const InvoicesPage = () => {
  return (
    <>
      <Helmet>
        <title>My Invoices | Virewire Property Services</title>
        <meta name="description" content="View and manage your invoices with Virewire." />
      </Helmet>

      <DashboardLayout>
        <div className="w-full">
          {/* Header */}
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-primary">My Invoices</h1>
            <p className="text-muted-foreground">View and download your invoices</p>
          </div>

          {/* Invoices Content */}
          <Card>
            <CardContent className="p-6">
              <InvoiceSection />
            </CardContent>
          </Card>
        </div>
      </DashboardLayout>
    </>
  );
};

export default InvoicesPage;